import { TenantRoleDto } from '@admin/app/api'
import { useTranslate } from '@tolgee/react'
import { TomAutoComplete, TomAutoCompleteProps } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

type Props<M extends boolean = false> = {
  options: TenantRoleDto[]
  onChange: (roles: M extends true ? TenantRoleDto[] : TenantRoleDto) => void
} & TomAutoCompleteProps<TenantRoleDto, M>

export const RolesAutoComplete = observer(<M extends boolean = false>(props: Props<M>) => {
  const { t } = useTranslate()
  const { dataCy, defaultValue, label, onChange, options } = props

  return (
    <TomAutoComplete
      {...props}
      dataCy={dataCy ?? 'roles-autocomplete'}
      label={label ?? t('roles', 'Roles')}
      options={options}
      defaultValue={defaultValue}
      entityKey='id'
      enablePortal
      placeholder={t('selectRoles', 'Select roles')}
      onChangeEntity={entity => {
        onChange(entity as M extends true ? TenantRoleDto[] : TenantRoleDto)
      }}
    />
  )
})
